import { gql } from '@apollo/client';

export const GET_RISE_AI_AVAILABILITY = gql`
  query riseAIAvailability($args: RiseAIAnalysisDataInput!) {
    riseAIAvailability(args: $args) {
      available
      status
      eligible
    }
  }
`;

export const GET_RISE_AI_ANALYSIS_DATA = gql`
  query riseAIAnalysisData($args: RiseAIAnalysisDataInput!) {
    riseAIAnalysisData(args: $args) {
      findingsCount
    }
  }
`;

export const SUBMIT_RISE_AI_ANALYSIS = gql`
  mutation submitRiseAIAnalysis($args: RiseAIAnalysisDataInput!) {
    submitRiseAIAnalysis(args: $args) {
      status
    }
  }
`;
